interface IProps {
    title: string | React.ReactNode;
    content: string | React.ReactNode;
    style?: React.CSSProperties;
    styles?: { container?: React.CSSProperties, title?: React.CSSProperties, content?: React.CSSProperties };
    className?: { container?: string, title?: string, content?: string };
}
const InlineWellnessTicketReceipt = ({ title, content, style, styles, className }: IProps) => {
    return <div className={"body/b2 " + (className?.container ?? '')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 'var(--space12)', ...style, ...styles?.container }} >
        <div className={"secondary/s800 " + (className?.title ?? '')} style={{ whiteSpace: 'nowrap', marginRight: 8, ...styles?.title }}>{title}</div>
        <div className={"base/black " + (className?.content ?? '')} style={{ whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis', ...styles?.content }}>{content}</div>
    </div>
}
export { InlineWellnessTicketReceipt }